module.exports = __webpack_public_path__ + "static/media/home2.006c85cd.jpg";